/* Copyright 2013 - 2024 Waiterio LLC */
const colorPrimary = '#2390ff'

export default colorPrimary
